import {Component, Input} from '@angular/core';
import {AddOffer, OfferingService, ProductOffering} from '@uofu-uss-aux/software-catalog-ng-core';
import {LicensingService} from '../licensing.service';
import {DatePipe, NgIf} from "@angular/common";
import {WarningComponent} from "../../warning/warning.component";

@Component({
  selector: 'app-license-expiration-warning',
  templateUrl: './license-expiration-warning.component.html',
  styleUrls: ['./license-expiration-warning.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    DatePipe,
    WarningComponent
  ]
})
export class LicenseExpirationWarningComponent {

  earliestEndDate: Date;
  anyExpireWithinNinetyDays = false;


  constructor(private readonly licensingService: LicensingService,
              private readonly offeringService: OfferingService) {
  }

  @Input()
  set offerings(offers: ReadonlyArray<ProductOffering>) {
    this.earliestEndDate = this.licensingService.pickEarliestEndDate(offers || []);
    this.anyExpireWithinNinetyDays = (!!this.earliestEndDate &&
        this.offeringService.expiresWithin(this.earliestEndDate, 90));
  }
}
